"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactIntl = require("react-intl");
var _style = _interopRequireDefault(require("./style"));
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _response = require("../../utils/response");
var _stripe = require("../../stripe");
var _api = require("../../api");
var _adapters = require("../../api/adapters");
var _hooks = require("../../hooks");
var _BillingAddress = require("../BillingAddress");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const CardForm = _ref => {
  let {
    onCancel,
    onSuccess,
    apiRequest,
    fetchSetupIntent = _api.fetchSetupIntent,
    defaultPaymentMethod,
    submitButtonProps = {},
    onCardValidated = () => {},
    onValidationFailed = () => {},
    buttonsContainerProps = {},
    submitButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "activate_new_subscription"
    }),
    cancelButtonText = /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "cancel"
    }),
    requestInProgress: passedRequestInProgress,
    countryCode: passedCountryCode = '',
    onCountryCodeChange: passedOnCountryCodeChange,
    zipCode: passedZipCode = '',
    onZipCodeChange: passedOnZipCodeChange,
    customer,
    addressDisabled: passedIsAddressDisabled = false,
    errorCaught: isErrorCaught = false,
    ...props
  } = _ref;
  const intl = (0, _reactIntl.useIntl)();
  const stripe = (0, _stripe.useStripe)();
  const elements = (0, _stripe.useElements)();
  const classes = (0, _style.default)(props);
  const {
    brandId,
    isInclusivePrices
  } = (0, _hooks.useConfig)();
  const isAddressEnabled = !passedIsAddressDisabled && isInclusivePrices;
  const [cardError, setCardError] = (0, _react.useState)(null);
  const [customerDeletionError, setCustomerDeletionError] = (0, _react.useState)(null);
  const [requestInProgress, setRequestInProgress] = (0, _react.useState)(false);
  const [attachPaymentMethodError, setAttachPaymentMethodError] = (0, _react.useState)(null);
  const [fetchingSetupIntentError, setFetchingSetupIntentError] = (0, _react.useState)();
  const [innerCountryCode, setInnerCountryCode] = (0, _react.useState)('');
  const [innerZipCode, setInnerZipCode] = (0, _react.useState)('');
  const [isZipCodeValid, setZipCodeValid] = (0, _react.useState)(true);
  const countryCode = customer ? innerCountryCode : passedCountryCode;
  const zipCode = customer ? innerZipCode : passedZipCode;
  const onCountryCodeChange = customer ? e => setInnerCountryCode(e.target.value) : passedOnCountryCodeChange;
  const onZipCodeChange = customer ? e => setInnerZipCode(e.target.value) : passedOnZipCodeChange;
  const loading = !!(requestInProgress || passedRequestInProgress);
  const onFormSubmit = async e => {
    e.preventDefault();
    setCardError(null);
    setAttachPaymentMethodError(null);
    setRequestInProgress(true);
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    if (customer && isAddressEnabled) {
      const customerAddress = (0, _adapters.getAdaptedCustomerAddress)(countryCode, zipCode);
      await (0, _api.updateCustomerAddress)(customer.id, customerAddress, brandId);
    }
    const [setupIntentError, setupIntent] = await fetchSetupIntent();
    setFetchingSetupIntentError(setupIntentError);
    if (setupIntentError) {
      setRequestInProgress(false);
      return;
    }
    const result = await stripe.confirmCardSetup(setupIntent.client_secret, {
      payment_method: {
        card: elements.getElement(_stripe.CardNumberElement)
      }
    });
    if (!result.error && result.setupIntent) {
      onCardValidated(setupIntent, result.setupIntent);
      if (apiRequest) {
        const [error, response] = await apiRequest(result.setupIntent.payment_method, {
          default: defaultPaymentMethod
        });
        if (!error && response) {
          onSuccess(response);
        } else {
          setAttachPaymentMethodError(error);
        }
      }
    } else {
      setCardError(result.error);
      const {
        registrationToken
      } = setupIntent;
      if (registrationToken) {
        const [error] = await (0, _api.deleteCustomer)(registrationToken);
        setCustomerDeletionError(error);
      }
      onValidationFailed();
    }
    setRequestInProgress(false);
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: onFormSubmit
  }, fetchingSetupIntentError && !isErrorCaught && /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(fetchingSetupIntentError)
  })), (cardError || attachPaymentMethodError) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: cardError?.message || (0, _response.getErrorMessage)(attachPaymentMethodError)
  })), customerDeletionError && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(customerDeletionError)
  })), isAddressEnabled && /*#__PURE__*/_react.default.createElement(_BillingAddress.BillingAddress, {
    countryCode: countryCode,
    onCountryCodeChange: onCountryCodeChange,
    zipCode: zipCode,
    onZipCodeChange: onZipCodeChange,
    zipCodeValid: isZipCodeValid,
    setZipCodeValid: setZipCodeValid,
    disabled: loading
  }), stripe && elements && /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 2,
    position: "relative"
  }, loading && /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    py: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    size: 100
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: loading && classes.cardProcessing
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "credit_card_number"
  })), /*#__PURE__*/_react.default.createElement(_stripe.CardNumberElement, {
    options: {
      showIcon: true,
      disabled: loading,
      classes: {
        base: classes.cardNumber
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: loading && classes.cardProcessing
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "card_expiration"
  })), /*#__PURE__*/_react.default.createElement(_stripe.CardExpiryElement, {
    options: {
      placeholder: intl.formatMessage({
        id: 'card_expiry_placeholder'
      }),
      disabled: loading,
      classes: {
        base: classes.cardExpiry
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    width: "100%",
    ml: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "card_cvc"
  })), /*#__PURE__*/_react.default.createElement(_stripe.CardCvcElement, {
    options: {
      disabled: loading,
      classes: {
        base: classes.cardCvc
      }
    }
  })))), /*#__PURE__*/_react.default.createElement(_core.Box, buttonsContainerProps, onCancel && /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: "inherit",
    onClick: onCancel,
    variant: "contained",
    disabled: loading,
    "data-testid": "cancel-button"
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement(_core.Button, _extends({
    type: "submit",
    color: "primary",
    variant: "contained",
    disabled: requestInProgress || !elements || !stripe || passedRequestInProgress || !isZipCodeValid
  }, submitButtonProps, {
    "data-testid": "submit-button"
  }), submitButtonText)));
};
exports.CardForm = CardForm;